import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { HttpAzureFunctions } from '@application/common/constants/http-azure-functions';
import { addInfoNotification } from '@application/features/common/notificationSlice';
import { useAppDispatch } from '@application/store/useStore';
import LocalStorageService from '@infrastructure/local-storage-service';
import { visserApi } from '@infrastructure/visserApi';
import VnButton from '@ui/components/VnButton';
import { refreshOutline } from 'ionicons/icons';
const TimeChimpSync = () => {
    const dispatch = useAppDispatch();
    //---------TimeChimpRelatedMethods---------------
    const handleButtonClickSyncTasks = () => {
        const accessToken = LocalStorageService.getAccessToken();
        const url = `${process.env.REACT_APP_AZURE_FUNCTIONS_HTTP_TRIGGER}${HttpAzureFunctions.ImportHttpTasks}`;
        visserApi
            .post(url, {}, {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        })
            .then(() => {
            console.log('HTTP POST trigger for ImportTimeChimpDataTasks was called.');
        })
            .catch((error) => {
            console.error('Error calling HTTP trigger:', error);
        });
        dispatch(addInfoNotification('hour type is gesynchroniseerd'));
    };
    const handleButtonClickSyncTags = () => {
        const accessToken = LocalStorageService.getAccessToken();
        const url = `${process.env.REACT_APP_AZURE_FUNCTIONS_HTTP_TRIGGER}${HttpAzureFunctions.ImportHttpTags}`;
        visserApi
            .post(url, {}, {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        })
            .then(() => { })
            .catch(() => { });
        dispatch(addInfoNotification('werktype is gesynchroniseerd'));
    };
    const handleButtonClickSyncTimes = () => {
        const accessToken = LocalStorageService.getAccessToken();
        const url = `${process.env.REACT_APP_AZURE_FUNCTIONS_HTTP_TRIGGER}${HttpAzureFunctions.ImportHttpTimes}`;
        visserApi
            .post(url, {}, {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        })
            .then(() => {
            console.log('HTTP POST trigger for ImportTimeChimpDataTasks was called.');
        })
            .catch((error) => {
            console.error('Error calling HTTP trigger:', error);
        });
        dispatch(addInfoNotification('Werkorder hour is gesynchroniseerd'));
    };
    const handleButtonClickSyncWorkorder = () => {
        const accessToken = LocalStorageService.getAccessToken();
        const url = `${process.env.REACT_APP_AZURE_FUNCTIONS_HTTP_TRIGGER}${HttpAzureFunctions.SyncWorkorders}`;
        visserApi
            .post(url, {}, {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        })
            .then(() => {
            console.log('HTTP POST trigger for ImportTimeChimpDataTasks was called.');
        })
            .catch((error) => {
            console.error('Error calling HTTP trigger:', error);
        });
        dispatch(addInfoNotification('Werkorder is gesynchroniseerd'));
    };
    const handleButtonClickSyncCustomers = () => {
        const accessToken = LocalStorageService.getAccessToken();
        const url = `${process.env.REACT_APP_AZURE_FUNCTIONS_HTTP_TRIGGER}${HttpAzureFunctions.SyncCustomers}`;
        visserApi
            .post(url, {}, {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        })
            .then(() => {
            console.log('HTTP POST trigger for ImportTimeChimpDataTasks was called.');
        })
            .catch((error) => {
            console.error('Error calling HTTP trigger:', error);
        });
        dispatch(addInfoNotification('Klant is gesynchroniseerd'));
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: 'd-flex justify-content-between mb-3', children: [_jsx("div", { children: "Klant:" }), _jsx("div", { children: _jsx(VnButton, { type: 'button', mode: 'primary', size: 'sm', customClassName: 'vn-add-button', icon: refreshOutline, onClick: handleButtonClickSyncCustomers, children: "Sync" }) })] }), _jsxs("div", { className: 'd-flex justify-content-between mb-3', children: [_jsx("div", { children: "Werkorder:" }), _jsx("div", { children: _jsx(VnButton, { type: 'button', mode: 'primary', size: 'sm', customClassName: 'vn-add-button', icon: refreshOutline, onClick: handleButtonClickSyncWorkorder, children: "Sync" }) })] }), _jsxs("div", { className: 'd-flex justify-content-between mb-3', children: [_jsx("div", { children: "Werktype:" }), _jsx("div", { children: _jsx(VnButton, { type: 'button', mode: 'primary', size: 'sm', customClassName: 'vn-add-button', icon: refreshOutline, onClick: handleButtonClickSyncTags, children: "Sync" }) })] }), _jsxs("div", { className: 'd-flex justify-content-between mb-3', children: [_jsx("div", { children: "Uursoort:" }), _jsx("div", { children: _jsx(VnButton, { type: 'button', mode: 'primary', size: 'sm', customClassName: 'vn-add-button', icon: refreshOutline, onClick: handleButtonClickSyncTasks, children: "Sync" }) })] }), _jsxs("div", { className: 'd-flex justify-content-between mb-3', children: [_jsx("div", { children: "Werkorder Uren:" }), _jsx("div", { children: _jsx(VnButton, { type: 'button', mode: 'primary', size: 'sm', customClassName: 'vn-add-button', icon: refreshOutline, onClick: handleButtonClickSyncTimes, children: "Sync" }) })] })] }));
};
export default TimeChimpSync;
